import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';

/* WELCOME TO THE MESSAGING BUS!! READ ME!!!
So as we developed the application we ran into a series of
dependency issues. Low level service tended to reference each 
other and this caused lots of problems. The service was created 
to remove dependency problems, but we should not over use this 
to solve dependency related issues. We want our dependency 
graph to make sense and this is just to handle the issues we
could not find a logical way around.

PLEASE USE RESPONSIBLY!!!

I used Replay Subject since I wanted to make sure that no
messages are missed since one of the use cases forefront in my
mind is an auto-logout due to an API 401 failure. This means you
get all the messages that have happened.
*/

// If you are going to add a message, please type it here.
// Every message should have a 'type'

class SystemMessage {}

export class LogoutMessage extends SystemMessage {
    constructor(public redirect?: string) {
        super();
    }
}

export class ErrorNotificationMessage extends SystemMessage {
    constructor(
        public headerKey: string,
        public bodyKey: string
    ) {
        super();
    }
}

export class TranslationsLoadedMessage extends SystemMessage {
    constructor() {
        super();
    }
}

export class ApplicationInitializedMessage extends SystemMessage {
    constructor() {
        super();
    }
}

export class LegacyModuleAccessInitializedMessage extends SystemMessage {
    constructor() {
        super();
    }
}

@Injectable({ providedIn: 'root' })
export class MessagingService {
    messageBus = new ReplaySubject<SystemMessage>();

    sendMessage(message: SystemMessage) {
        this.messageBus.next(message);
    }

    // listenFor<LogMessage>(LogMessage)
    listenFor<T>(messageClass): Observable<T> {
        return <Observable<T>>(
            this.messageBus.pipe(
                filter((systemMessage) => systemMessage instanceof messageClass)
            )
        );
    }
}
